import React, { Component } from 'react';
import './UnitMarker.css';
import ParameterErrors from '../errors/ParameterErrors';
import getAbsolute from '../ui_core/getAbsolute';
import Rect from '../geometry/Rect';
import PlotStatus from '../site/PlotStatus';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import enableBindingToOthers from '../mvvm/enableBindingToOthers';
const{throwNotProvided} = ParameterErrors;
export default class UnitMarker extends Component {
	constructor(props){
		super(props)
		const {siteJson, unit, position, onHover, onClick}=props;
		if(!siteJson)throwNotProvided('siteJson');
		if(!unit)throwNotProvided('unit');
		this._siteJson = siteJson;
		this._unit = unit;
		this._position = position;
		if(!onHover)throwNotProvided('onHover');
		if(!onClick)throwNotProvided('onClick');
		this._callbackOnHover = onHover;
		this._callbackOnClick = onClick;
		this._handleMouseEnter = this._handleMouseEnter.bind(this);
		this._handleMouseLeave = this._handleMouseLeave.bind(this);
		this._handleClick = this._handleClick.bind(this);
		this._handleActiveChanged=this._handleActiveChanged.bind(this);
		this._handleSelectedChanged=this._handleSelectedChanged.bind(this);
		this._dispatchCallbackOnHover=this._dispatchCallbackOnHover.bind(this);
		this._getMarkerPosition=this._getMarkerPosition.bind(this);
		this.getMouseInBounds = this.getMouseInBounds.bind(this);
		this._releaseUnitActiveHandle= this._releaseUnitActiveHandle.bind(this);
		this._element = React.createRef();
		this.deactivate = this.deactivate.bind(this);
		unit.addEventListener('active', this._handleActiveChanged);
		const propertyBindingSelected = PropertyBindingFactory.standard(this, unit, 'selected', this._handleSelectedChanged);
		this.state ={filteredOut:false, position:position, hovering:false, active:false, favourite:propertyBindingSelected.get()};
		
	}
	set filteredOut(value){
		this.setState({filteredOut: value});
	}
	get position(){
		return this._position;
	}
	get unit(){
		return this._unit;
	}
	getMouseInBounds(point){
		const element = this._element.current;
		if(element===null)return;
		const absolutePosition = getAbsolute(element);
		const containsPoint =  new Rect({x:absolutePosition.left, y:absolutePosition.top, width:element.offsetWidth, height:element.offsetHeight})
		.containsPoint(point);
		return containsPoint;
	}
	_handleActiveChanged(e){
		const active = e.active;
		if(active!==this.state.active)
			this.setState({active:active});
		
	}
	_handleMouseEnter(e){
		this.setState({hovering:true});
		this._releaseUnitActiveHandle();
		this._currentUnitActiveHandle=this._unit.takeActiveHandle();
		this._dispatchCallbackOnHover(true);
	}
	_handleMouseLeave(e){
		this.setState({hovering:false});
		this._releaseUnitActiveHandle();
		this._dispatchCallbackOnHover(false);
	}
	_getMarkerPosition(){
        const element = this._element.current;
		const absolutePosition = getAbsolute(element);
		return [absolutePosition.left+(element.offsetWidth/2), absolutePosition.top+(element.offsetHeight/2)];
	}
	_dispatchCallbackOnHover(hovering){
		this._callbackOnHover({hovering:hovering, markerPosition:this._getMarkerPosition(), marker:this});
	}
	_handleClick(){
		this._callbackOnClick({markerPosition:this._getMarkerPosition(), marker:this});
	}
	_releaseUnitActiveHandle(){
		if(!this._currentUnitActiveHandle)return;
		this._currentUnitActiveHandle.dispose();
		this._currentUnitActiveHandle=null;
	}
	_handleSelectedChanged(value){
		this.setState({favourite:value});
	}
	deactivate(){
		this._releaseUnitActiveHandle();
	}
	render() {
		let className="unit-marker";
		if(this.state.active)
			className+=" active";
		if(this.state.favourite)
			className+=" favourite";
		if(this.state.filteredOut)
			className+=" filtered-out";
		const unit = this._unit;
		const availablePlots = unit.plots.filter(plot=>plot.status===PlotStatus.AVAILABLE);
		const comingSoonPlots = unit.plots.filter(plot=>plot.status===PlotStatus.COMING_SOON);
		const reservedPlots = unit.plots.filter(plot=>plot.status===PlotStatus.RESERVED);
		const plotStatus = availablePlots.length>0
			?PlotStatus.AVAILABLE
			:(
				comingSoonPlots.length>0
				?PlotStatus.COMING_SOON
				:(
					reservedPlots.length>0
					?PlotStatus.RESERVED
					:(
						unit.plots.length>0?unit.plots[0].status:
						PlotStatus.SOLD_OR_UNAVAILABLE)
				)
			);
			
		if(!unit.hasMoreThanOneUnit)
			className+=` ${PlotStatus.getCssName(plotStatus)}`;
		return (<div className={className} ref={this._element} style={{left:`${this.state.position.x}%`, top:`${this.state.position.y}%`}} 
			onMouseEnter={this._handleMouseEnter} onMouseLeave={this._handleMouseLeave} onClick={this._handleClick}>
			<div className="inner"></div>
		</div>)
	}
}
